/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Remove_TitleInputs */

const en_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Speaker`)
};

const fr_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le locuteur`)
};

const de_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautsprecher entfernen`)
};

const it_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi altoparlante`)
};

const ru_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить динамик`)
};

const es_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar el altavoz`)
};

const zh_cn2_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除扬声器`)
};

const ja_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを削除`)
};

const hi_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पीकर हटाएँ`)
};

const pt_pt2_speaker_manager_remove_title = /** @type {(inputs: Speaker_Manager_Remove_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover alto-falante`)
};

/**
* | output |
* | --- |
* | "Remove Speaker" |
*
* @param {Speaker_Manager_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_remove_title = /** @type {((inputs?: Speaker_Manager_Remove_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Remove_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_remove_title(inputs)
	if (locale === "de") return de_speaker_manager_remove_title(inputs)
	if (locale === "it") return it_speaker_manager_remove_title(inputs)
	if (locale === "ru") return ru_speaker_manager_remove_title(inputs)
	if (locale === "es") return es_speaker_manager_remove_title(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_remove_title(inputs)
	if (locale === "ja") return ja_speaker_manager_remove_title(inputs)
	if (locale === "hi") return hi_speaker_manager_remove_title(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_remove_title(inputs)
	return en_speaker_manager_remove_title(inputs)
});